var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl } from "../../../utils/evo";
import { getPurchases, validateConsent } from "../../evo-client/__generated__";
import { createClient, createConfig } from "../../evo-client/__generated__/client";
export class OlaApiEvo {
    constructor(baseUrl, tenantToken, ciamToken, userUuid, recaptchaId) {
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
        this.recaptchaId = recaptchaId;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    getOfflinePurchases() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const response = yield getPurchases({
                client: this.client,
                headers: {
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.ciamToken,
                },
                path: {
                    uuid: this.userUuid,
                },
            });
            return Promise.resolve({
                data: ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : []).map(({ external_created_at, items, type, uuid }) => ({
                    action_id: uuid,
                    datetime: external_created_at,
                    type,
                    items,
                })),
            });
        });
    }
    validateHash(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data } = yield validateConsent({
                client: this.client,
                path: {
                    hash,
                },
                headers: {
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-TENANT": this.tenantToken,
                },
            });
            return {
                token: (_a = data === null || data === void 0 ? void 0 : data.token) !== null && _a !== void 0 ? _a : null,
            };
        });
    }
}
//# sourceMappingURL=OlaApiEvo.js.map